/* global DfApi */

import { Extension } from '@tiptap/core';

const api = () => new DfApi();

const AutoSaveTasks = Extension.create({
  name: 'autoSaveTasks',
  onCreate({ editor }) {
    storeTaskId(editor);
  },
  onUpdate({ editor }) {
    scheduleSaveContent(editor);
  },
});

const storeTaskId = (editor) => {
  const matches = /\/tasks\/(\d+)/.exec(window.location.href);

  if (matches) {
    editor.storage.taskId = matches[1];
  } else {
    alert('⚠️ Tasks feature is not working properly, please contact customer service');
  }
};

const scheduleSaveContent = (editor, timeout = 2000) => {
  const autoSaveTimerId = editor.storage.autoSaveTimerId;

  if (autoSaveTimerId) {
    window.clearTimeout(autoSaveTimerId);
  }
  editor.storage.autoSaveTimerId = window.setTimeout(saveContent, timeout, editor);
};

const saveContent = async (editor) => {
  try {
    const content = editor.getHTML();
    const response = await api().saveTaskNotes(editor.storage.taskId, content);

    response.ok ? saveContentSuccess(editor, response) : saveContentError(editor);
  } catch (error) {
    console.error('saveContent: failed to save the editor content', error);
    saveContentError(editor);
  }
};

const saveContentSuccess = async (editor, response) => {
  try {
    const date = await response.json();

    editor.storage.lastSavedAt = date ? new Date(date) : new Date();
  } catch (error) {
    console.error('saveContentSuccess: error parsing saved date', error);
    editor.storage.lastSavedAt = new Date();
  }
};

const saveContentError = (editor) => {
  scheduleSaveContent(editor, 10000);
};

export default [AutoSaveTasks];
